import { useEffect } from 'react';
import useSubmitInteractiveEmailDeflectionFeedback from './InteractiveEmail/hooks/useSubmitInteractiveEmailDeflectionFeedback';

export const EndInteractiveEmailChatStep = () => {
  const { onSubmit } = useSubmitInteractiveEmailDeflectionFeedback({
    isDeflected: false,
  });

  useEffect(() => {
    onSubmit();
  }, [onSubmit]);

  return null;
};
